import React from 'react';
import { TextField } from 'formik-material-ui';
import { Field, useFormikContext } from 'formik';
import {
  Box,
  Grid,
  Typography,
  MenuItem,
  FormControl,
} from '@material-ui/core';
import styled from 'styled-components';

const LeftTypography = styled(Typography)`
  margin-right: 1rem;
`;

function TwoColumnField({ left, right, ...rest }) {
  const { values } = useFormikContext();
  return (
    <Box m={1}>
      <Grid
        item
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        // spacing={3}
        xs={12}
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={3}
          xs={6}
        >
          {left && (
            <>
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                xs={6}
              >
                <Typography variant="subtitle2">{left.label}</Typography>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Field
                    component={left.component || TextField}
                    name={left.name}
                    label={values[left.name] ? '' : left.label}
                    required={left.required}
                    variant="outlined"
                    size="medium"
                    fullWidth
                    select={!!left.options}
                    InputLabelProps={{
                      shrink: false,
                    }}
                  >
                    {left.options &&
                      left.options.map((opt) => {
                        return (
                          <MenuItem value={opt.value}>{opt.label}</MenuItem>
                        );
                      })}
                  </Field>
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          // spacing={3}
          xs={6}
        >
          {right && (
            <>
              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                xs={6}
              >
                <LeftTypography variant="subtitle2">
                  {right.label}
                </LeftTypography>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <Field
                    component={right.component || TextField}
                    name={right.name}
                    label={values[right.name] ? '' : right.label}
                    required={right.required}
                    variant="outlined"
                    size="medium"
                    select={!!right.options}
                    fullWidth
                    InputLabelProps={{
                      shrink: false,
                    }}
                  >
                    {right.options &&
                      right.options.map((opt) => {
                        return (
                          <MenuItem value={opt.value}>{opt.label}</MenuItem>
                        );
                      })}
                  </Field>
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default TwoColumnField;
